<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row mt-4">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} Guide Card</h3>
            </div>
            <v-stepper v-model="e1" light>
              <v-stepper-header >
                <v-stepper-step :complete="e1 > 1" step="1" editable>Guide Card Details</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step v-if="!isEdit" :complete="e1 > 2" step="2">Guide Card Icon</v-stepper-step>
                <v-stepper-step v-if="isEdit" :complete="e1 > 2" step="2" @click="updateStep" editable>Guide Card Icon</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content class="v-form-body" step="1">
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    enctype="multipart/form-data"
                  >
                    <v-row>
                      <v-col cols="12">
                        <label class="form-control-label">
                          Name
                          <span class="red--text">*</span>
                        </label>
                        <v-text-field
                          v-model="guideCard.name"
                          placeholder="Enter Guide Card Name"
                          :rules="rules"
                          required
                          solo
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12">
                        <label class="form-control-label">
                          Description
                          <span class="red--text">*</span>
                        </label>
                        <quill-editor
                          v-model="guideCard.description"
                          @input="error=[]"
                          ref="myQuillEditor"
                          :options="editorOption"
                        ></quill-editor>
                        <div v-if="error && error.length > 0" class="v-text-field__details pt-2 pl-2"><div class="v-messages theme--light error--text" role="alert"><div class="v-messages__wrapper"><div class="v-messages__message">{{ error[0] }}</div></div></div></div>
                      </v-col>

                      <v-col class="text-right" cols="12">
                        <v-btn
                          color="#989898"
                          class="mr-4 white--text"
                          @click="cancel"
                          >Cancel</v-btn
                        >
                        <v-btn
                          v-if="!isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="saveStep"
                          >Next</v-btn
                        >
                         <v-btn
                          v-if="isEdit"
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="updateStep"
                          >Next</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                 <v-stepper-content class="v-form-body" step="2">
                   <v-row>
                    <v-col
                      :class="$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12'"
                      class="pa-5"
                    >
                      <v-card>
                        <v-card-title>
                          <span class="Subtitle 1">Upload Icon</span>
                        </v-card-title>
                        <v-card-text>
                          <vue-dropzone
                            class="vue-dropzone-box"
                            ref="myVueDropzone"
                            id="dropzone"
                            :destroyDropzone="false"
                            :options="dropzoneOptions"
                            @vdropzone-sending="beforecomplete"
                            @vdropzone-success="aftercomplete"
                            @vdropzone-mounted="uploadedImage"
                            @vdropzone-removed-file="removeFile"
                            :useCustomSlot="true"
                            :useCustomDropzoneOptions="true"
                          >
                            <div class="dropzone-custom-content">
                              <img src="@/assets/images/ImageUpload.svg" />
                              <h3 class="font-weight-light ma-0">
                                Drag and drop here to upload
                              </h3>
                              <h3 class="font-weight-light ma-0">Or</h3>
                              <h3 class="dropzone-custom-title">Browse</h3>
                            </div>
                          </vue-dropzone>
                        </v-card-text>
                      </v-card>
                    </v-col>
                     <v-col class="text-right" cols="12">
                        <v-btn
                          color="#989898"
                          class="mr-4 white--text"
                          @click="back"
                          >Back</v-btn
                        >
                        <v-btn
                          :disabled="!valid"
                          :loading="loading"
                          color="#344452"
                          class="white--text"
                          @click="save"
                          >{{(isEdit) ? 'Update' : 'Save'}}</v-btn
                        >
                      </v-col>
                  </v-row>
                 </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import CommonSection from "@/components/CommonHeader";
import { guideCardService, MediaService } from "@/services";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "AddGuideCard",
  components: {
    CommonSection,
    quillEditor,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      e1:1,
      loading: false,
      valid: true,
      guideCard: {
        name: null,
        description: null,
      },
      editorOption: {
        theme: "snow",
      },
      error : [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        addRemoveLinks: true,
        thumbnailWidth: 400,
        autoProcessQueue: true,
        maxFilesize: 2,
        maxFiles: 1,
        dictFileTooBig:"File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        headers: {
          Authorization: `Bearer ${store.state.user.token}`,
        },
        init() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 2) {
              // not more than 2mb
              this.removeFile(file);
            }
          });
        },
        acceptedFiles: "image/*",
      },
      guideCardId:null,
      media: [],
      isEdit : false,
      rules: [
        v => !!v || 'Name is required!', 
        v => v && !!v.trim() || 'Field cannot be blank',
      ],
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    async initialize(){
      if (this.$route.params.id !== 'create') {
        this.isEdit = true;
        await this.getGuideCardData();
        await this.uploadedImage();
      }
    },
    isEmpty () {
      return this.editor.getText().trim().length === 0
    },
    beforecomplete(file, xhr, formData) {
      formData.append("mediaType", "image");
      formData.append("moduleType", "guideCard");
      formData.append("mediaSubType", "file");
      formData.append("moduleId", this.guideCardId);
    },
    aftercomplete() {
      this.$store.dispatch(
        "user/setSnack",
        "Guide Card icon uploaded successfully!"
      );
      this.getGuideCardData();
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        this.media.filter((media) => {
          if (media.mediaType == "image") {
            var file = {
              size: media.size,
              name: media.name,
              type: media.type,
            };
            this.$refs.myVueDropzone.manuallyAddFile(file, media.url);
          }
        });
      }
    },
    async getGuideCardData() {
      if (this.$route.params.id !== 'create') {
        const guideCard = await guideCardService.getGuideCard(this.$route.params.id);
        this.guideCard.name = guideCard.data.data[0].name;
        this.guideCard.description = guideCard.data.data[0].description;
        this.media = guideCard.data.data[0].media;
      }
    },
    removeFile(file) {
      if (file.size > 1024 * 1024 * 2) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 2MB File size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture(file);
    },
    async deletePicture(file) {
      try {
        if (file) {
          let mediaId = this.media.filter((media) => {
            if (media.mediaType == "image" && media.name == file.name) {
              return media._id;
            }
          });
          if (mediaId.length > 0) {
            const response = await MediaService.deleteMedia({
              id: mediaId[0]._id,
              body: {
                moduleType: "guideCard",
                moduleId: this.guideCardId,
              },
            });
            this.getGuideCardData();
            if (response) {
              this.$store.dispatch(
                "user/setSnack",
                "Guide Card icon deleted successfully!"
              );
              this.$store.dispatch("user/setType", "info");
            }
          }
        }
      } catch (error) {
        this.$store.dispatch("user/setSnack", error);
        this.$store.dispatch("user/setType", "error");
      }
    },
    back() {
      this.e1 = 1;
    },
    cancel() {
      this.$router.push("/guide-card");
    },
    async saveStep() {
      const value = this.isEmpty();
      if (this.$refs.form.validate() && !value) {
        this.loading = true;
        try {
          const response = await guideCardService.createGuideCard(this.guideCard);
          if (response) {
            this.e1 = 2;
            this.guideCardId = response.data.id;
            this.loading = false;
            this.$store.dispatch("user/setSnack", `Guide Card added successfully!`);
            this.$store.dispatch("user/setType", "info");
          }
          else {
            this.loading = false;
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      } else if(value) {
        this.error.push('Description is required!')
      }
    },
    async updateStep() {
      const value = this.isEmpty();
      if (this.$refs.form.validate() && !value) {
        this.loading = true;
        try {
          const response = await guideCardService.updateGuideCard({
            id: this.$route.params.id,
            object: this.guideCard,
          });
          this.guideCardId = response.data.id;
          this.loading = false;
          if (response) {
            this.e1 = 2;
            this.$store.dispatch("user/setSnack", "Guide Card updated successfully!");
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      } else if(value) {
        this.error.push('Description is required!')
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          this.loading = false;
          this.$router.push("/guide-card");
          this.$store.dispatch("user/setSnack", `Guide Card ${(this.isEdit) ? 'updated' : 'added'} successfully!`);
          this.$store.dispatch("user/setType", "info");
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.main-content .navbar-top {
  display: none !important;
}
</style>